import './Banner.css'
import React, { useRef, useState } from 'react';
import { AiOutlineCloudDownload } from 'react-icons/ai'
import { BsFacebook, BsGithub, BsLinkedin } from 'react-icons/bs'
import { useInView } from 'react-intersection-observer';


const Banner = () => {
    const { ref, inView, entry } = useInView({
        threshold: .4,
    });


    return (
        <div className='banner'>
            <div className="banner-img"></div>
            <div className="banner-text">
                <h1>
                    <p style={{ color: '#ffb400' }}>
                        <span
                            style={{
                                fontFamily: `'MonteCarlo', cursive`
                            }}
                        >Hi ,</span><br />
                        I'M FOYSAL BIN NOUR.
                    </p>
                    Full-Stack Web Developer
                </h1>
                <p>I am a Full-Stack Web Developer. I can build unique looking website for you. </p>
                <a
                    href="https://drive.google.com/file/d/1WJeChJjtWB2jBd_wV22gIq1Ac-cj_f1S/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                    className='resume-link'
                >My Resume <AiOutlineCloudDownload className='icon' /></a>

                {/* i will add swocial links here */}
                <div
                    ref={ref}
                    className='observer'
                >observer</div>

                <div className={inView ? "social-links" : "social-links-side"} >
                    {/* <div className="social-links-side"> */}
                    <a href="http://facebook.com/annoms.rd" target="_blank" rel="noopener noreferrer">
                        <BsFacebook className='icon' />
                    </a>
                    <a href="http://facebook.com/annoms.rd" target="_blank" rel="noopener noreferrer">
                        <BsLinkedin className='icon' />
                    </a>
                    <a href="http://facebook.com/annoms.rd" target="_blank" rel="noopener noreferrer">
                        <BsGithub className='icon' />
                    </a>
                </div>


            </div>
        </div >
    );
};

export default Banner;